import { Button, Dropdown, SkeletonBox } from '@billy/design-system'
import { ReactElement, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useInvoiceColumnVisibilitySettingsForm } from '../../../../../../../../contexts/invoiceColumnVisibilityFormContext'
import { useInvoiceEditorDocumentType } from '../../../../../../../../hooks/useInvoiceEditorDocumentType'
import { useIsInvoiceEditorElementRestricted } from '../../../../../../../../hooks/useIsInvoiceEditorElementRestricted'
import { InvoiceColumnsVisibilitySettings } from './elements/InvoiceColumnsVisibilitySettings'

export const InvoiceEditLinesColumns = (): ReactElement | null => {
  const { t } = useTranslation()
  const { isFormDataLoaded } = useInvoiceColumnVisibilitySettingsForm()
  const { isCreditNote } = useInvoiceEditorDocumentType()
  const isColumnVisibilityButtonHidden = useIsInvoiceEditorElementRestricted('columnVisibilityButton', 'hidden')
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const handleDropdownOpen = useCallback(() => setIsDropdownOpen(true), [])
  const handleDropdownClose = useCallback(() => setIsDropdownOpen(false), [])

  if (isCreditNote || isColumnVisibilityButtonHidden) {
    return null
  }

  if (!isFormDataLoaded) {
    return <SkeletonBox height={40} width={140} />
  }

  return (
    <Dropdown
      onClose={handleDropdownClose}
      onOpen={handleDropdownOpen}
      placement="bottom-start"
      trigger={
        <Button
          active={isDropdownOpen}
          icon="columns"
          iconRight={isDropdownOpen ? 'chevronUp' : 'chevronDown'}
          size="md"
          variant="text"
        >
          {t('external_invoices.editor.form.field.invoice_lines.edit_columns_button')}
        </Button>
      }
      width={180}
    >
      <InvoiceColumnsVisibilitySettings />
    </Dropdown>
  )
}
